/**
 * @file loadscene.js
 * @desc This module contains LoadScene class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

var Scene = require('scene').Scene;
var Animation = require('animation').Animation;

(/** @lends <global> */function (global) {
    'use strict';
    
    var loadBarWidth = 0;
    
    /**
     * Constructs LoadScene object.
     * @class
     * @constructor
     * @name LoadScene
     * @classdesc This is game preloader screen. Shows resources preloading progress and network connection indicator.
     * @extends {Scene}
     * @requires Scene
     * */
    var LoadScene = function(config) {
        Scene.call(this);
    
        this.loadScreen = new PIXI.Sprite(PIXI.utils.TextureCache[config.loadscreen.image || "res/loadscreen.jpg"]);
        this.addChild(this.loadScreen);

        this.loadBar = new PIXI.Sprite(PIXI.utils.TextureCache[config.loadscreen.loadbar.image || "res/loadbar.png"]);
        loadBarWidth = this.loadBar.width;
        // progress bar initially is zero length
        this.loadBar.texture.frame.width = 0;
        this.loadBar.x = config.loadscreen.loadbar.position.x;
        this.loadBar.y = config.loadscreen.loadbar.position.y;
        this.addChild(this.loadBar);

        this.connectionIndicator = Animation.byFrameName("load_process_indicator_%03d.png", 12);
        this.connectionIndicator.position.set(config.resolution.width / 2, config.resolution.height / 2);
        this.connectionIndicator.anchor.set(0.5, 0.5);
        this.connectionIndicator.loop = true;
        this.connectionIndicator.animationSpeed = 0.2;
        this.addChild(this.connectionIndicator);
        
        if (config.loadscreen.music) {
            
            this.loadSound = new Howl({
                src: [config.loadscreen.music],
                autoplay: true,
                // preload : true,
                html5: true,
                loop: false,
                volume: 0.5
            });
            this.loadSound.loop(false);
            if (config.loadscreen.musicLoop) {
                this.loadSound.loop(config.loadscreen.musicLoop);
            }
            // this.loadSound.play();
        }
    };
    
    LoadScene.prototype = Object.create(Scene.prototype);
    
    LoadScene.prototype.constructor = LoadScene;
    
    LoadScene.prototype.destroy = function(textures, baseTextures) {
        Scene.prototype.destroy.call(this, textures, baseTextures);
        
        this.loadScreen = null;
        this.loadBar = null;
        this.connectionIndicator = null;

        if (this.loadSound) {
            this.loadSound = null;
        }
    
        // PIXI.utils.TextureCache["res/loadscreen.jpg"].destroy(true);
        // PIXI.utils.TextureCache["res/loadbar.png"].destroy(true);

    };
    
    
    /**
     * Hides network connection indicator.
     * */
    LoadScene.prototype.hideConnectionIndicator = function () {
        this.connectionIndicator.visible = false;
        this.connectionIndicator.gotoAndStop(0);
    };
    
    
    /**
     * Update load progress indicator.
     * @param {Number} progress [0.0 - 1.0] where 1.0 means fully loaded game
     * */
    LoadScene.prototype.updateProgress = function (progress) {
        if (progress >= 0.99) {
            progress = 1.0;
            if (this.loadSound) {
                this.loadSound.loop(false);
                this.loadSound.fade(0.5, 0, 500);
            }
        }
        
        this.loadBar.texture.frame.width = loadBarWidth * progress;
        this.loadBar.texture._updateUvs();
    };
    
    global.LoadScene = LoadScene;
}(typeof module === 'object' && module.exports || this));



//////////////////
// WEBPACK FOOTER
// ./src/library/loadscene.js
// module id = 92
// module chunks = 0